module.exports = __webpack_public_path__ + "img/iOS-active.c9741ed.svg";